import { ConfigService } from "src/app/services/config.service";
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxDataGridModule,
  DxFormModule,
  DxSelectBoxModule,
  DxToastModule,
  DxTreeListModule,
} from "devextreme-angular";
import { DxoButtonOptionsModule } from "devextreme-angular/ui/nested";
import { AppGlobals } from "src/app/app.globals";
import { DeletePopupComponent } from "src/app/components/delete-popup/delete-popup.component";
import { environment } from "src/environments/environment";
import { ProjectCostsService } from "src/app/services/project-costs.service";
import {
  DxTreeListComponent,
  DxTreeListTypes,
} from "devextreme-angular/ui/tree-list";

import { DxDataGridTypes } from "devextreme-angular/ui/data-grid";
import { RowDraggingMoveEvent } from "devextreme/ui/tree_list";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
@Component({
    selector: "app-config-cost-categories",
    imports: [
    GpdButtonComponent,
    SvgIconComponent,
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        DxToastModule,
        DxTreeListModule,
        DxSelectBoxModule,
        DeletePopupComponent,
        DxFormModule,
        SearchableDropdownDirective,
    ],
    templateUrl: "./config-cost-categories.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./config-cost-categories.css"]
})
export class ConfigCostCategoriesPage implements OnInit {
  @ViewChild("treelist", { static: false }) catConfigList: DxTreeListComponent;
  projectCostCategories: any = [];

  deletePopupMessage: any = $localize`Are you sure you want to delete this item?`;
  deletePopupVisible: boolean = false;
  editingIndex: any = null;
  rowToEdit: any;
  expandAll: boolean = false;
  itemTodelete: any = {};
  currentEditRowKey: any = null;
  departmentsList: any = [];
  editData: any;
  titleRequired: any = $localize`Category Name is required`;
  departmentRequired: any = $localize`Department is required`;

  type: any = "";
  message: any = "";
  toastVisible: boolean = false;
  toastMessage: string = $localize`Successfully saved`;

  deleteClicked: boolean = false;
  isNewCategory: boolean = false;

  newTaskGridIndex: number;

  treeDataSourceSorted: any = [];

  previousRowCategoryId: any = "";
  newPrimaryCat: any = {};
  oldPrimaryCat: any = {};
  dropOrAddInCat: boolean | null;

  constructor(
    private service: ConfigService,
    private appGlobals: AppGlobals,
    private projectCostsService: ProjectCostsService,
    private activityLog: ActivityLogService
  ) { }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_COST_CATEGORIES });
    this.getProjectCostCategories();
  }

  getProjectCostCategories(): void {
    this.projectCostsService.getProjectCostCategories({}).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.projectCostCategories = result.projectCostCategories;
          this.treeDataSourceSorted = this.projectCostCategories;
          //  this.assignTreeListIDs(this.projectCostCategories, 0, 0);
          this.departmentsList = result.departmentsList;

          // Assign Level and item order
          for (let i = 0; i < this.treeDataSourceSorted.length; i++) {
            if (this.treeDataSourceSorted[i].primaryCategoryId === null) {
              this.treeDataSourceSorted[i].itemLevel = 1;
            } else {
              let primaryCat = this.treeDataSourceSorted.filter(
                (item) =>
                  item.id === this.treeDataSourceSorted[i].primaryCategoryId
              );
              if (primaryCat.primaryCategoryId === null) {
                this.treeDataSourceSorted[i].itemLevel = 3;
              } else {
                this.treeDataSourceSorted[i].itemLevel = 2;
              }
            }
          }
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  setEditData(e: any): void {
    this.editData = e.data;
  }

  editSelectedRow(e: any): void {
    this.rowToEdit = e.data;
    this.expandAll = true;
    if (this.currentEditRowKey !== null && this.currentEditRowKey !== e.key) {
      // Cancel the current row's editing
      this.onEditCanceling();
    }
    this.editData = e.data;
    this.currentEditRowKey = e.key;
    setTimeout(() => {
      //let row = this.catConfigList.instance.getVisibleRows().filter(row => row.data.id === e.row.data.id)[0].rowIndex;
      let row = e.rowIndex;
      this.catConfigList.instance.editRow(row);
      //  if (this.newTask() === true) {
      //    e.data.taskId = '';
      //   this.rowToEdit.data.taskId = '';
      //  }
    }, 100);
  }

  deleteItem(e: any): void {
    this.deleteClicked = true;
    this.deletePopupVisible = true;
    this.itemTodelete = e.data;
  }

  onEditCanceling() {
    this.catConfigList.instance.cancelEditData();
    this.getProjectCostCategories();
    this.editData = null;
    this.currentEditRowKey = null;
  }

  writeCategory(e: any): void {
    if (this.editData != null) {
      //Find Index of current CAt and then find it's previous row  index, then id
      let currentCatIndex = this.catConfigList.instance.getRowIndexByKey(
        this.editData.id
      );
      let previousRowIndex = currentCatIndex - 1;
      let previousRowId =
        this.catConfigList.instance.getKeyByRowIndex(previousRowIndex);

      let sameNameBool = false;
      if (this.editData.id === -1) {
        let treeDataSourceSorted = this.treeDataSourceSorted.filter(
          (item) => item.id !== -1
        );
        for (let i = 0; i < treeDataSourceSorted.length; i++) {
          if (
            treeDataSourceSorted[i].categoryName === this.editData.categoryName
          ) {
            AppGlobals.ShowErrorMessage(
              $localize`Category Name already exists.`
            );
            sameNameBool = true;
          }
        }
      }
      if (sameNameBool != true) {
        let categoryToSave = {
          ID: this.editData.id,
          CategoryName: this.editData.categoryName,
          PrimaryCategoryId: this.editData.primaryCategoryId,
          DisplayOrder: this.editData.displayOrder,
          DepartmentId: this.editData.departmentId,
          Deleted: null,
        };
        let saveObject = {
          CurrentCat: categoryToSave,
          DropInCatId: null,
          PriorOrderingCatId: previousRowId,
        };

        this.writeCall(saveObject);
      }
    } else {
      //Find Index of current CAt and then find it's previous row  index, then id
      let saveObject = {
        CurrentCat: e.CurrentCat,
        DropInCatId: e.DropInCatId,
        PriorOrderingCatId: e.PriorOrderingCatId,
      };

      this.writeCall(saveObject);
    }
  }

  writeCall(e: any): void {
    this.projectCostsService.writeProjectCostCategory(e).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.saveToast({
            type: "success",
            feedback: $localize`:@@saved:Saved`,
          });
          this.getProjectCostCategories();
          this.onEditCanceling();
          if (this.deleteClicked === true) {
            this.toastMessage = $localize`Successfully deleted`;
          } else {
            this.toastMessage = $localize`Successfully saved`;
          }
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveToast(e: any): void {
    const type = e.type ? "success" : "error";
    if ((this.type = "success")) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage(
        $localize`:@@errorTryAgain:ERROR: There was an error, please try again.`
      );
    }
    this.type = type;
    this.toastVisible = true;
  }

  onDeleteAbort() {
    this.deletePopupVisible = false;
    this.deleteClicked = false;
  }

  onDeleteSelection() {
    this.deleteClicked = false;

    let categoryToSave = {
      Id: this.itemTodelete.id,
      CategoryName: this.itemTodelete.categoryName,
      PrimaryCategoryId: this.itemTodelete.primaryCategoryId,
      DisplayOrder: this.itemTodelete.displayOrder,
      DepartmentId: this.itemTodelete.departmentId,
      Deleted: "true",
    };
    let saveObject = {
      CurrentCat: categoryToSave,
      DropInCatId: null,
      PriorOrderingCatId: null,
    };
    this.projectCostsService.writeProjectCostCategory(saveObject).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
          this.deletePopupVisible = false;
        } else {
          this.saveToast({
            type: "success",
            feedback: $localize`:@@deleted:Deleted`,
          });
          this.getProjectCostCategories();
          this.deletePopupVisible = false;
          this.itemTodelete = null;
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  openSaveOptions(item: any): void { }

  getNewCategory() {
    return {
      id: -1,
      categoryName: "",
      itemLevel: null,
      displayOrder: 0,
      departmentId: null,
      primaryCategoryId: null,
      deleted: null,
    };
  }

  showContextMenu(e) {
    if (e.row.rowType != "data") return;

    let rowAtIndex = e.rowIndex;

    e.items = [];
    let insertAtTier = {
      text: $localize`:addCatBeneathGroup:Add a category beneath this group`,
      //  text: $localize`Add Category`,

      onItemClick: () => {
        //  this.disableSiteTask = false;
        let insertAtItem = e.row.data;
        let newCat = this.getNewCategory();
        this.expandAll = true;

        // newCat.id = Math.floor(Math.random() * 1000000);
        //// GET NEW SOTING INDEX
        let sortingIndexCounter = 0;

        newCat.displayOrder = insertAtItem.displayOrder + 1;
        newCat.primaryCategoryId = insertAtItem.primaryCategoryId;
        newCat.itemLevel = insertAtItem.itemLevel;

        // newTask.priorTaskId = insertAtItem.taskId;
        this.treeDataSourceSorted.push(newCat);
        this.catConfigList.instance.refresh();
        setTimeout(() => {
          let newItemIndex = this.catConfigList.instance.getRowIndexByKey(
            newCat.id
          );
          let priorCatIndex = newItemIndex - 1;
          //Get id of previous row
          this.previousRowCategoryId =
            this.catConfigList.instance.getKeyByRowIndex(priorCatIndex);
          let newItemElement: any =
            this.catConfigList.instance.getRowElement(newItemIndex);
          const scrollable = this.catConfigList.instance.getScrollable();
          // Scroll so the element sits at the top of the view
          if (
            newItemElement &&
            newItemElement.length > 0 &&
            scrollable != undefined
          ) {
            const element = newItemElement[0];
            const scrollableContent = scrollable.content();
            const elementOffset = element.offsetTop;
            const scrollableOffset = scrollableContent.offsetTop;
            const distanceToScroll = elementOffset - scrollableOffset;
            scrollable.scrollTo({ top: distanceToScroll });
          }
          this.newTaskGridIndex = newItemIndex;
          setTimeout(() => {
            let toEdit = {
              key: newCat.id,
              data: newCat,
              isEditing: true,
              row: {
                data: newCat,
              },
            };

            this.editData = toEdit.data;
            this.catConfigList.instance.option("editing.editRowKey", newCat.id);
          }, 100);
        }, 100);
      },
    };
    let insertInTier = {
      text: $localize`:addCatToGroup:Add a category to this group`,

      onItemClick: () => {
        //  this.disableSiteTask = false;
        let insertInItem = e.row.data;
        let newCat = this.getNewCategory();
        this.expandAll = true;
        // newCat.id = Math.floor(Math.random() * 1000000);
        //// GET NEW SOTING INDEX
        let sortingIndexCounter = 0;

        //THIS IS FOR INSERT IN!!!!
        for (let i = 0; i < this.treeDataSourceSorted.length; i++) {
          if (
            this.treeDataSourceSorted[i].primaryCategoryId === insertInItem.id
          ) {
            sortingIndexCounter += 1;
          }
        }
        newCat.displayOrder = sortingIndexCounter + 1;
        newCat.primaryCategoryId = insertInItem.id;
        newCat.itemLevel = insertInItem.itemLevel + 1;
        this.newPrimaryCat = this.catConfigList.instance.getNodeByKey(
          insertInItem.id
        ).data;

        // newTask.priorTaskId = insertAtItem.taskId;
        this.treeDataSourceSorted.push(newCat);
        this.catConfigList.instance.refresh();

        setTimeout(() => {
          let newItemIndex = this.catConfigList.instance.getRowIndexByKey(
            newCat.id
          );
          let priorCatIndex = newItemIndex - 1;
          //Get id of previous row
          this.previousRowCategoryId =
            this.catConfigList.instance.getKeyByRowIndex(priorCatIndex);
          let newItemElement: any =
            this.catConfigList.instance.getRowElement(newItemIndex);
          const scrollable = this.catConfigList.instance.getScrollable();
          // Scroll so the element sits at the top of the view
          if (
            newItemElement &&
            newItemElement.length > 0 &&
            scrollable != undefined
          ) {
            const element = newItemElement[0];
            const scrollableContent = scrollable.content();
            const elementOffset = element.offsetTop;
            const scrollableOffset = scrollableContent.offsetTop;
            const distanceToScroll = elementOffset - scrollableOffset;
            scrollable.scrollTo({ top: distanceToScroll });
          }
          this.newTaskGridIndex = newItemIndex;
          setTimeout(() => {
            let toEdit = {
              key: newCat.id,
              data: newCat,
              isEditing: true,
              row: {
                data: newCat,
              },
            };

            this.catConfigList.instance.expandRow(insertInItem.id);
            this.editData = toEdit.data;
            this.catConfigList.instance.option("editing.editRowKey", newCat.id);
          }, 100);
        }, 100);
      },
    };

    if (e.row.data.itemLevel === 1) {
      e.items.push(insertAtTier);
      e.items.push(insertInTier);
    } else {
      if (e.row.data.itemLevel === 3) {
        e.items.push(insertAtTier);
      } else {
        if (e.row.data.itemLevel === 2) {
          e.items.push(insertAtTier);
          e.items.push(insertInTier);
        } else {
          e.items.push(insertAtTier);
          e.items.push(insertInTier);
        }
      }
    }
  }

  /*     async assignTreeListIDs(categories: any, cat: any, subCat: any) {
            for (let i = 0; i < categories.length; i++) {
                if (cat === 0) {
                    categories[i].treeId = i + 1;
                    categories[i].treeCategoryId = cat;
                    this.treeDataSourceSorted.push(categories[i]);
                } else {
                    if (subCat != 0) {
                        categories[i].treeId = cat + '_' + subCat + '_' + (i + 1);
                        categories[i].treeCategoryId = cat + '_' + subCat
                        this.treeDataSourceSorted.push(categories[i]);
                    } else {
                        this.treeDataSourceSorted.push(categories[i]);
                    }
                }
                if (categories[i].subCategories.length > 0) {
                    let subCategory = categories[i].subCategories;
                    for (let a = 0; a < subCategory.length; a++) {
                        let idlayer = '_';
                        categories[i].subCategories[a].treeId = categories[i].treeId + idlayer + (a + 1);
                        categories[i].subCategories[a].treeCategoryId = categories[i].treeId;
                        this.treeDataSourceSorted.push(categories[i].subCategories[a]);
                        if (categories[i].subCategories[a].subCategories.length > 0) {
                            this.assignTreeListIDs(categories[i].subCategories[a].subCategories, (i + 1), (a + 1));
                        }
                    }
                }
            }
        } */

  draggedRowData: any = null;
  onRowDragMove = (e: RowDraggingMoveEvent) => {
    if (e.itemData.itemLevel === 1) {
      e.cancel = true;
    } else {
      setTimeout(() => {
        this.draggedRowData = {
          itemData: e.itemData,
          fromIndex: e.fromIndex,
          toIndex: e.toIndex,
          dropInsideItem: e.dropInsideItem,
        };
      }, 200);
    }
  };

  rowReordered = (
    e: Parameters<DxDataGridTypes.RowDragging["onReorder"]>[0]
  ) => {
    this.editData = null;

    let visibleRows = e.component.getVisibleRows();

    let targetData: any = null;
    targetData = visibleRows[e.toIndex]?.data;

    let payload: any = {};
    if (e.dropInsideItem === true) {
      let childCats = this.treeDataSourceSorted.filter(
        (item) => item.primaryCategoryId == targetData?.id
      );
      e.itemData.displayOrder = childCats.length + 1;
      e.itemData.primaryCategoryId = targetData?.id;

      payload = {
        CurrentCat: e.itemData,
        DropInCatId: targetData?.id,
        PriorOrderingCatId: null,
      };
    } else {
      if (e.itemData.primaryCategoryId != targetData.primaryCategoryId) {
        AppGlobals.ShowErrorMessage(
          $localize`:@@addCategoryToGroup:Please add Category to Group first`
        );
        return;
      }
      if (e.fromIndex > e.toIndex) {
        targetData = visibleRows[e.toIndex - 1].data;
      }

      payload = {
        CurrentCat: e.itemData,
        DropInCatId: null,
        PriorOrderingCatId: targetData.id,
      };
    }
    this.writeCategory(payload);
  };

  addCategory() {
    const newCat = this.getNewCategory();

    newCat.primaryCategoryId = null;
    newCat.itemLevel = 1;
    newCat.displayOrder = this.getNextDisplayOrderForRoot();

    this.expandAll = true;

    this.treeDataSourceSorted.push(newCat);
    this.catConfigList.instance.refresh();

    setTimeout(() => {
      const newItemIndex = this.catConfigList.instance.getRowIndexByKey(
        newCat.id
      );
      const newItemElement: any =
        this.catConfigList.instance.getRowElement(newItemIndex);
      const scrollable = this.catConfigList.instance.getScrollable();

      if (
        newItemElement &&
        newItemElement.length > 0 &&
        scrollable !== undefined
      ) {
        const element = newItemElement[0];
        const scrollableContent = scrollable.content();
        const elementOffset = element.offsetTop;
        const scrollableOffset = scrollableContent.offsetTop;
        const distanceToScroll = elementOffset - scrollableOffset;
        scrollable.scrollTo({ top: distanceToScroll });
      }

      setTimeout(() => {
        this.editData = newCat;
        this.catConfigList.instance.option("editing.editRowKey", newCat.id);
      }, 100);
    }, 100);
  }

  getNextDisplayOrderForRoot(): number {
    const rootItems = this.treeDataSourceSorted.filter(
      (cat) => cat.itemLevel === 1
    );
    if (rootItems.length === 0) return 1;
    return Math.max(...rootItems.map((cat) => cat.displayOrder || 0)) + 1;
  }
}
